import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-aum',
  templateUrl: './card-aum.component.html',
  styleUrls: ['./card-aum.component.scss']
})
export class CardAumComponent implements OnInit {

  @Input() total: string;
  @Input() currencyBreakdown;

  currencyColor = {
    USD: 'green',
    EUR: 'amber',
    JPY: 'purple',
    GBP: 'blue',
  }

  constructor() { }

  ngOnInit(): void {
  }

}
